import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { JobService } from 'src/app/services/job.service';
import { SearchData } from 'src/app/services/searchData';
import { UtilService } from 'src/app/services/util.service';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-common-profile-info',
  standalone: true,
  imports: [CommonModule,

    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './common-profile-info.component.html',
  styleUrls: ['./common-profile-info.component.scss']
})
export class CommonProfileInfoComponent implements OnInit, AfterViewInit {

  @Input('type') type: any;
  @Input() userIdInput: String;
  @Input() page: String;
  @Input('src') srcImg: any;
  userinfo: any = []
  @Input('data') data: any;

  img: any;
  // Broken/stale candidate photo fileId — flip back to the initials tile.
  imgFailed = false;

  constructor(private JobServicecolor: JobService, private cdRef: ChangeDetectorRef, private auth: ApiService, private router: Router, private searchdata: SearchData, private util: UtilService) {
    if (this.type && this.type === 'HASHTAG') {
      this.img = 'assets/images/hashtag.png';
    } else if (this.type && this.type === 'BUSINESS') {
      this.img = 'assets/images/gallery/company.png';
    }
  }

  ngOnInit() {
    // Candidate rows show the CANDIDATE's own uploaded photo (data.photo, a
    // bare fileId in the list payload — the widgets only pre-prefix
    // user.photo). Set it here so it doesn't depend on the user/{id} call.
    // The API can return the literal string 'null' — treat as no photo.
    if ((this.page === 'CANDIDATES' || this.page === 'CANDIDATES_MIGHT')
        && this.data?.photo && this.data.photo !== 'null') {
      this.img = this.getPhotoUrl(this.data.photo);
    }
    this.userprofile();
  }


  getInitialstwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }

  getColortwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }
  getTextColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getTextColor(firstname, lastname);
  }

  // First Unicode LETTER of a string ('' if none) — so titles like ".Net"
  // yield "N" and symbol-only words like "+" are skippable.
  private firstLetter(s: string): string {
    const m = (s || '').match(/\p{L}/u);
    return m ? m[0] : '';
  }

  // Job rows (page 'JOBS'/'SUGGJOBS') show a job-title initials tile instead
  // of the poster's photo — job-profile-slider header rule, letters only:
  // first letters of the first two words that contain a letter, uppercased
  // (".Net + XAMARIN + AZURE Developer" → "NX", "Senior Cloud Architect" → "SC").
  get jobInitials(): string {
    const words = (this.data?.jobTitle || '').trim().split(/\s+/)
      .filter(w => this.firstLetter(w) !== '');
    const i = words.slice(0, 2).map(w => this.firstLetter(w)).join('');
    return (i || 'J').toUpperCase();
  }

  /**
   * Get the full photo URL, avoiding duplication if the photo already contains the base URL
   */
  getPhotoUrl(photo: string): string {
    if (!photo) {
      return '';
    }
    // If photo already starts with http/https, return as-is
    if (photo.startsWith('http://') || photo.startsWith('https://')) {
      return photo;
    }
    // Otherwise, prepend the base URL
    return AppSettings.photoUrl + photo;
  }

  userprofile() {

    if (this.userIdInput != undefined) {
      this.auth.query("user/" + this.userIdInput).subscribe(userres => {
        if (this.page == "BUSINESS") {
          if (this.data.businessLogo != undefined && this.data.businessLogo != null) {
            this.img = this.getPhotoUrl(this.data.businessLogo);
          } else {
            this.img = "assets/images/gallery/company.png"
          }
          this.userinfo = userres;
        } else if (this.page == "COMMUNITY") {
          if (this.data.communityLogo != undefined && this.data.communityLogo != null) {
            this.img = this.getPhotoUrl(this.data.communityLogo);
          } else {
            this.img = "assets/icon/comm.png"
          }
          this.userinfo = userres;
        }
        else if (this.page == "JOBS") {
          if (this.data.user && this.data.user.photo) {
            this.img = this.getPhotoUrl(this.data.user.photo);
          }
          this.userinfo = userres;
        }
        else if (this.page == "SUGGJOBS") {
          if (this.data.user != null && this.data.user.photo) {
            this.img = this.getPhotoUrl(this.data.user.photo);
          }
          this.userinfo = userres;
        }
        else if (this.page == "CANDIDATES_MIGHT") {
          // img is the candidate's own photo (set in ngOnInit) — don't
          // overwrite it with the poster's user.photo.
          this.userinfo = userres;
        }
        else if (this.page == "CANDIDATES") {
          this.userinfo = userres;
        }
        else {
          if (userres.photo) {
            this.img = this.getPhotoUrl(userres.photo);
          }
          this.userinfo = userres;
        }

      }, err => {
        this.util.stopLoader();
      });
    }
    else
      this.img = null

  }

  route(data, val) {

    if (val == true || this.page == "PeopleMayYouKnow") {
      if (this.type == "BUSINESS") {

        if (this.data != undefined && this.data != null && this.data != "") {
          // this.router.navigate(['business'], { queryParams: this.data, replaceUrl: true });

          this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
            this.router.navigate(["business"], { queryParams: this.data });
          });
        }

      }
      else if (this.type == "COMMUNITY") {
        setTimeout(() => {
          // this.router.navigate(['community'], { queryParams: this.data, replaceUrl: true });
          this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
            this.router.navigate(["community"], { queryParams: this.data });
          });
        }, 80);

      }
      else if (this.userIdInput != null && this.page == "PeopleMayYouKnow") {
        let data: any = {}
        data.userId = this.userIdInput;
        this.router.navigate(["personalProfile"], { queryParams: data });
      }
      else if (this.type === "MOSTACTIVE") {
        let userId = data.userId;
        if (data.userId != "") {
          // this.router.navigate(['personalProfile'], { queryParams: { "userId": userId }, replaceUrl: true });
          this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
            this.router.navigate(["personalProfile"], { queryParams: { "userId": userId } });
          });
        }
      }

    } else {
      this.searchdata.setWidget(true);
    }
  }


  ngAfterViewInit() {
    if (this.type && this.type === 'HASHTAG') {
      this.img = 'assets/images/hashtag.png';
    } else if (this.type && this.type === 'BUSINESS') {
      this.img = 'assets/images/gallery/company.png';
    }

    this.cdRef.detectChanges();
  }


  datapass(data) {
  }
}
